import { call, put } from "redux-saga/effects";
import {
  fetchUserFiltersData,
  deleteUserFilter,
  saveUserFilters
} from "../requests/userFIltersStore";

import {
  setUserFilters,
  setUserFiltersLoading,
  setUserFiltersError
} from "../../entities/userFiltersStore";

export function* handleGetUserFiltersData() {
  try {
    yield put(setUserFiltersLoading());
    const data = yield call(fetchUserFiltersData);
    yield put(setUserFilters(data));
  } catch (e) {
    yield put(setUserFiltersError(e.message));
  }
}

export function* handleDeleteUserFilter(action) {
  try {
    yield call(deleteUserFilter, action.payload);
    const data = yield call(fetchUserFiltersData);
    yield put(setUserFilters(data));
  } catch (e) {
    yield put(setUserFiltersError(e.message));
  }
}

export function* handleSaveUserFilters(action) {
  const { selectedCars, userid, maxMakesAllowed } = action.payload;
  try {
    yield call(saveUserFilters, selectedCars, userid, maxMakesAllowed);
    const updated = yield call(fetchUserFiltersData);
    yield put(setUserFilters(updated));
  } catch (e) {
    yield put(setUserFiltersError(e.message));
  }
}
